import { render, staticRenderFns } from "./TaskConfigurationPanel.vue?vue&type=template&id=0d20cbbe&"
import script from "./TaskConfigurationPanel.vue?vue&type=script&lang=ts&"
export * from "./TaskConfigurationPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports